// import './App.css';
// import Router from './Router';

// function App() {
//   return (
//    <Router />
//   );
// }

// export default App;

import React, { useEffect, useState } from "react";
import './App.css';
import Router from './Router';
import axios from "axios";
import ServerError from "./components/server/ServerError";

function App() {
  const [serverError, setServerError] = useState(false);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error?.response?.status === 502 ||
          (error.response === undefined && error.message === "Network Error")
        ) {
          setServerError(true);
        }
        return Promise.reject(error);
      }
    );

    // return () => {
    //   axios.interceptors.response.eject(interceptor);
    // };
  }, []);

  return (
    <>
      {serverError && <ServerError/>}
      <Router />
    </>
  );
}

export default App;
